import axios from 'axios'
import { API } from '../actionTypes'
import { apiError, accessDenied } from '../actionCreators/api'

const apiMiddleware = store => next => action => {
  next(action)
  
  if (action.type !== API) return
  
  const {
    url,
    method,
    data,
    params,
    onSuccess,
    onFailure,
    label
  } = action.payload
  const accessToken = store.getState().oidc.user.access_token
  
  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL || ""
  axios.defaults.headers.common["Content-Type"] = "application/json"
  axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`
  
  axios.request({
    url,
    method,
    data,
    params
  }).then(({ data }) => {
    store.dispatch(onSuccess(data))
  }).catch(error => {
    console.log(error)
    store.dispatch(apiError(label, error))
    onFailure(error)
    
    if (error.response && error.response.status === 403) {
      store.dispatch(accessDenied(window.location.pathname))
    }
  })
}

export default apiMiddleware